export enum WatchHistoryTypes {
  FetchRequest = 'watch-history/FETCH_REQUEST',
  FetchSuccess = 'watch-history/FETCH_SUCCESS',
  FetchFailure = 'watch-history/FETCH_FAILURE',
  SetWatched = 'watch-history/SET_WATCHED',
}

export type WatchHistory = { [key: string]: boolean };
